import React, { useState,useEffect } from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import "react-datepicker/dist/react-datepicker.css";  
import CommonAPI from '../Common/CommonAPI';
import CommonAPI2 from '../Common/FD_BILL_APIs';
import FadeLoader from "react-spinners/HashLoader"; 
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

function FDSummaryPDF  (props)  {   

    const [SuccessLoading,setSuccessLoading] =useState(true);
    const [FDList,setFDList]  =useState([]);

    const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }

    const GetFDAPI  = () =>{
        CommonAPI2.FixedDeposits((results) =>{   
            if(results){                    
                setFDList(results.fdList.filter(e=>e.status ==="WDR")); 
                setSuccessLoading(false)
            }            
        });
      } 

    useEffect( () => {
        GetFDAPI();  
      },[])  ;


    const DownloadDocument = () =>{
        const input = document.getElementById('printdiv');
        html2canvas(input)
          .then((canvas) => {
            var imgWidth = 210;
            var pageHeight = 295;
            var imgHeight = canvas.height * imgWidth / canvas.width;
            var heightLeft = imgHeight;
            var position = 0;

            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', [300, 210]);
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                 position = heightLeft - imgHeight;
                 pdf.addPage();
                 pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                 heightLeft -= pageHeight;
               }

            //pdf.output('dataurlnewwindow');
            pdf.save("FD_Summary.pdf");
          })
        ;
       }
if(SuccessLoading){
    return(  <ResponseLoadingModal />)
}

    return(
            <Modal  
                show={props.show}             
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered 
                backdrop="static"
                onHide={props.onHide}
                >
                <div id="printdiv">
                    <Modal.Header closeButton>
                        <Modal.Title className='modal-t' id="contained-modal-title-vcenter">            
                        <div className='modal-t'>
                            <img className="profile-img2" src={require('../images/logo.png')} alt="logo"/>
                            <font color="black">SENKADAGALA FINANCE PLC</font>
                        </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Form >
                    <p className='t-left form-h2'>{moment(new Date(), 'DD MMMM YYYY').format('Do')+' '+moment(new Date()).format('MMMM YYYY')}</p>
                    <p className='t-left form-h2 s-top'><u>CONFIRMATION OF DEPOSITS</u></p>
                    <Table className='block-top' hover responsive>
                        <thead >
                            <tr>
                            <th className='td-width9'>No<p></p></th>
                            <th className='td-width'>Deposit<br/> Number</th>
                            <th className='td-width'>Capital<br/>LKR</th>
                            <th className='td-width'>Interest<br/> Amount LKR</th>
                            <th className='td-width'>Total<br/> LKR</th>
                            <th className='td-width'>Interest <br/>Paid LKR</th>
                            <th className='td-width'>Maturity<br/> Date</th> 
                            </tr>
                        </thead>
                        <tbody className='dtablebody'>
                        { FDList.map(( listValue, index )=> {
                                return(
                            <tr>
                                <td className='td-width9'>{index+1}</td>
                                <td className='td-width'>{listValue.fdNumber}</td>
                                <td className='td-width'>{listValue.depositAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                <td className='td-width'>{listValue.totalInterestAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                <td className='td-width'>{(listValue.depositAmount+listValue.totalInterestAmount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                <td className='td-width'>{listValue.paidAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                <td className='td-width'>{moment(listValue.matirutyDate).format('DD/MM/YYYY')}</td>
                            </tr>
                                )
                        })
                            }
                        </tbody>
                    </Table>
                    <p style={{justifyContent:'center',fontSize:14,marginTop:20,}}>
                            The above {FDList.length >1? "deposits are" :"deposit is"} free from lien or encumbrances and payable on maturity at the customer’s request.<br/><br/>
                            Please feel free to contact the undersigned for any further clarifications you may require.<br/><br/>
                            Yours faithfully<br/>
                            SENKADAGALA FINANCE PLC<br/><br/>
                            Isha Dias<br/>
                            Senior Manager – Deposits & Savings
                            </p>
                    {/**<Row lg={12}>                            
                        <Col lg={12} className='rmv-pad3 block text-color'>
                            <Row  className='dtableHead'>
                                <Col lg={1}>
                                    <div>
                                    <p className=' m-top'>No</p>
                                    </div>
                                </Col>
                                <Col lg={1}>
                                    <div>
                                    <p className=' m-top'>Deposit Number</p>
                                    </div>
                                </Col>
                                <Col lg={2}>
                                    <div>
                                    <p className='m-top'>Capital LKR</p>
                                    </div>
                                </Col>
                                <Col lg={2}>                        
                                    <div>
                                    <p className=' m-top'>Interest Amount LKR</p>
                                    </div>                        
                                </Col>
                                <Col lg={2}>                        
                                    <div>
                                    <p className='m-top'>Total LKR</p>
                                    </div>                        
                                </Col>
                                <Col lg={2}>                        
                                    <div>
                                    <p className='m-top'>Interest Paid LKR</p>
                                    </div>                        
                                </Col>
                                <Col lg={2}>                        
                                    <div>
                                    <p className='m-top'>Maturity Date</p>
                                    </div>                        
                                </Col>
                                                   
                            </Row>
                            <div >
                            { FDList.map(( listValue, index )=> {
                                return(
                                    <Row  className='dtablebody'>
                                        <Col lg={1}>
                                            <div>
                                            <p className='m-top'>{index+1}</p>
                                            </div>
                                        </Col>
                                        <Col lg={1}>
                                            <div>
                                            <p className='m-top'>{listValue.fdNumber}</p>
                                            </div>
                                        </Col>
                                        <Col lg={2}>
                                            <div>
                                            <p className='m-top'>{listValue.depositAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                            </div>
                                        </Col>
                                        <Col lg={2}>
                                            <div>
                                            <p className='m-top'>{listValue.totalInterestAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                            </div>
                                        </Col>
                                        <Col lg={2}>
                                            <div>
                                            <p className=' m-top'>{(listValue.depositAmount+listValue.totalInterestAmount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                            </div>
                                        </Col>
                                        <Col lg={2}>
                                            <div>
                                            <p className='b-text m-top'>{listValue.paidAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                            </div>
                                        </Col>
                                        <Col lg={2}>
                                            <div>
                                            <p className='m-top t-center'>{moment(listValue.matirutyDate).format('DD/MM/YYYY')}</p>
                                            </div>
                                        </Col>
                                                                             
                                    </Row>
                                    )                                     
                                })
                            }
                            
                            </div>
                            <p style={{justifyContent:'center',fontSize:14,marginTop:20,}}>
                            The above {FDList.length >1? "deposits are" :"deposit is"} free from lien or encumbrances and payable on maturity at the customer’s request.<br/><br/>
                            Please feel free to contact the undersigned for any further clarifications you may require.<br/><br/>
                            Yours faithfully<br/>
                            SENKADAGALA FINANCE PLC<br/><br/>
                            Isha Dias<br/>
                            Senior Manager – Deposits & Savings
                            </p>
                        </Col>                            
                        </Row>**/ }
                        
                    </Form>                                   
                    </Modal.Body>
                </div>
                <Modal.Footer className="d-flex s-top justify-content-center"> 
                    <Button type="button" onClick={()=>DownloadDocument()}  className="btn-logout " >DOWNLOAD</Button>
                </Modal.Footer>   
            </Modal>
            );

}
export default FDSummaryPDF;